export const GET_ASTRONAUT_DETAILS_REQUEST = "GET_ASTRONAUT_DETAILS_REQUEST";
export const GET_ASTRONAUT_DETAILS_REQUEST_SUCCESS =
  "GET_ASTRONAUT_DETAILS_REQUEST_SUCCESS";
export const GET_ASTRONAUT_DETAILS_REQUEST_ERROR =
  "GET_ASTRONAUT_DETAILS_REQUEST_ERROR";
export const RESET_ASTRONAUT_DETAILS = "RESET_ASTRONAUT_DETAILS";
